import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "aos/dist/aos.css";
import AOS from "aos";
import "./Videos.css";
import Footer from "../Home/Footer";

const videosData = [
  {
    id: 1,
    title: "Introduction to Smart Farming",
    url: "https://www.youtube.com/embed/8KkKuTCFvzI",
    category: "Agriculture",
  },
  {
    id: 2,
    title: "Pest Management Tips",
    url: "https://www.youtube.com/embed/mz2f3yMqxEA",
    category: "Pest Control",
  },
  {
    id: 3,
    title: "Post-Harvest Storage Methods",
    url: "https://www.youtube.com/embed/5qap5aO4i9A",
    category: "Harvesting",
  },
  {
    id: 4,
    title: "Soil Health & Fertilization",
    url: "https://www.youtube.com/embed/tgbNymZ7vqY",
    category: "Soil & Fertilization",
  },
];

const categories = [
  "All",
  "Agriculture",
  "Pest Control",
  "Harvesting",
  "Soil & Fertilization",
];

const Videos = () => {
  const [selectedCategory, setSelectedCategory] = useState("All");

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const filteredVideos =
    selectedCategory === "All"
      ? videosData
      : videosData.filter((video) => video.category === selectedCategory);

  return (
    // <div className="videos-page">
    //   {/* Hero Section with Video Background */}
    //   <section className="video-hero">
    //     {/* Background Video */}
    //     <video autoPlay muted loop playsInline className="video-bg">
    //       <source src="https://www.shutterstock.com/shutterstock/videos/3434686531/preview/stock-footage-soybean-grain-in-a-hands-of-successful-farmer-in-tractor-trailer-after-harvest-for-transport-to-the.webm" type="video/mp4" />
    //       Your browser does not support the video tag.
    //     </video>

    //     {/* Overlay */}
    //     <div className="video-overlay"></div>

    //     {/* Text Content */}
    //     <div className="video-content">
    //       <h1 className="display-4 fw-bold" style={{color : "#d4561a"}}>Explore Our Video Library</h1>
    //     </div>
    //   </section>

    //   {/* Filter Section */}
    //   <div className="filter-section text-center my-4">
    //     {categories.map((cat) => (
    //       <button
    //         key={cat}
    //         className={`filter-btn ${selectedCategory === cat ? "active" : ""}`}
    //         onClick={() => setSelectedCategory(cat)}
    //       >
    //         {cat}
    //       </button>
    //     ))}
    //   </div>

    //   {/* Video Grid */}
    //   <section className="video-grid container">
    //     <div className="row">
    //       {filteredVideos.map((video) => (
    //         <div className="col-lg-4 col-md-6 mb-4" key={video.id} data-aos="fade-up">
    //           <div className="video-card shadow">
    //             <iframe
    //               width="100%"
    //               height="200"
    //               src={video.url}
    //               title={video.title}
    //               frameBorder="0"
    //               allowFullScreen
    //             ></iframe>
    //             <h5 className="video-title">{video.title}</h5>
    //           </div>
    //         </div>
    //       ))}
    //     </div>
    //   </section>
    //   <Footer/>
    // </div>
    <section id="recent-posts" className="recent-posts section">
      <div className="container">
        <div className="row justify-content-center text-center">
          <div className="col-lg-8">
            <div
              className="p-5 rounded shadow"
              style={{ backgroundColor: "#fff8e1" }}
            >
              <h2
                className="mb-3"
                style={{ fontSize: "2rem", color: "#ff6f00" }}
              >
                🚧 Coming Soon
              </h2>
              <p style={{ fontSize: "1.1rem", color: "#555" }}>
                This section is under construction. Stay tuned for our latest
                posts and updates!
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Videos;
